<template>
  <div class="my-4">
    <p class="text-h6">{{ title }}</p>

    <div v-for="(row, i) in value" :key="row.id || i">
      <v-row>
        <v-col cols="4">
          <p>{{ row.col1 }}</p>
        </v-col>
        <v-col cols="4">
          <p>{{ row.col2 }}</p>
        </v-col>
        <v-col cols="4">
          <div class="d-flex">
            <v-btn @click="deleteRow(i)" x-small color="white" class="ml-2" light>Delete</v-btn>
            <v-btn @click="editRow(i)" x-small color="white" class="ml-2" light>Edit</v-btn>
          </div>
        </v-col>
      </v-row>
    </div>

    <v-row>
      <v-col cols="6" class="my-0 py-0">
        <v-select :items="local.priorities" label="Time" v-model="draft.col1" light />
      </v-col>
      <v-col cols="6" class="my-0 py-0">
        <v-select :items="local.brand" label="Brands" v-model="draft.col2" light />
      </v-col>
      <v-col cols="12" class="my-0 py-0">
        <v-btn v-if="isEditing" @click="commitEdit" small color="grey" class="black--text my-4" light>Update</v-btn>
        <v-btn v-else @click="addRow" small color="grey" class="black--text my-4" light>Add</v-btn>
        <v-btn v-if="isEditing" @click="cancelEdit" small color="grey" class=" black--text ml-2" light>Cancel</v-btn>
      </v-col>
    </v-row>

  </div>
</template>

<script>

function uid() {
  return `${Date.now()}-${Math.floor(Math.random() * 1e6)}`;
}

const TEMPLATE = { id: null, col1: '', col2: '' };

export default {
  name: 'PhaseForm',
  // Vue 2 v-model = prop 'value' + event 'input'
  props: {
    value: { type: Array, default: () => [] },
    local: { type: Object, default: () => ({ priorities: [], brand: [] }) },
    title: { type: String, default: '' },
  },
  data() {
    return {
      draft: { ...TEMPLATE },
      isEditing: false,
      editIndex: -1,
    };
  },
  methods: {
    addRow() {
      const next = this.value.slice();
      next.push({ id: uid(), col1: this.draft.col1, col2: this.draft.col2 });
      this.$emit('input', next);        // keep parent in sync
      this.draft = { ...TEMPLATE };     // reset form
    },
    deleteRow(index) {
      const next = this.value.slice();
      next.splice(index, 1);
      this.$emit('input', next);
      if (this.isEditing && this.editIndex === index) this.cancelEdit();
    },
    editRow(index) {
      const row = this.value[index];
      this.editIndex = index;
      this.draft = { ...row };          // includes id so we preserve it
      this.isEditing = true;
    },
    cancelEdit() {
      this.isEditing = false;
      this.editIndex = -1;
      this.draft = { ...TEMPLATE };
    },
    commitEdit() {
      if (this.editIndex < 0) return;
      const next = this.value.slice();
      // ensure we keep the existing id if somehow missing
      const id = this.draft.id != null ? this.draft.id : (next[this.editIndex] && next[this.editIndex].id) || uid();
      const updated = { id, col1: this.draft.col1, col2: this.draft.col2 };
      // Using direct assignment is fine since we emit a new array;
      // $set also works but is not necessary when replacing the array.
      next[this.editIndex] = updated;
      this.$emit('input', next);
      this.cancelEdit();
    },
  },
};
</script>
